import {
  LEFT_PANEL_BLOCKS_FEATURE,
  LEFT_PANEL_BLOCKS_FAQ,
  LEFT_PANEL_BLOCKS_FOOTER,
  LEFT_PANEL_BLOCKS_HEADER,
  LEFT_PANEL_BLOCKS_HERO,
  LEFT_PANEL_BLOCKS_PRICING,
  LEFT_PANEL_BLOCKS_NAV,
  LEFT_PANEL_BLOCKS_TABLE,
  LEFT_PANEL_BLOCKS_LOGO,
  LEFT_PANEL_BLOCKS_HTML,
  LEFT_PANEL_BLOCKS_CONTENT,
  LEFT_PANEL_BLOCKS_TEAM,
  LEFT_PANEL_BLOCKS_FORM,
  LEFT_PANEL_BLOCKS_CTA,
  LEFT_PANEL_BLOCKS_TESTIMONIAL,
  LEFT_PANEL_BLOCK_CARDS,
  LEFT_PANEL_BLOCK_NAVBAR,
} from "../../../constants/labels.constants";
import * as JSONS from "../../../jsons";
import * as JSONS_RESTYLE from "../../../jsons_restyle";

/* import { FEATURE_BLOCK_1 } from "../../../jsons/block.feature.metadata";
import { PRICING_BLOCK_1 } from "../../../jsons/block.pricing.metadata";
import { FOOTER_BLOCK_1 } from "../../../jsons/block.footer.metadata"; */

// Block popup Header menu and corresponding items and meta data
const PANEL_BLOCKS_TYPES = {
  TYPE_LEFT_BLOCK_HEADER: "HEADER_ID",
  TYPE_LEFT_BLOCK_HERO: "HERO_ID",
  TYPE_LEFT_BLOCK_FEATURE: "FEATURE_ID",
  TYPE_LEFT_BLOCK_FAQ: "FAQ_ID",
  TYPE_LEFT_BLOCK_FEATURE_GRID: "FEATURE_GRID_ID",
  TYPE_LEFT_BLOCK_PRICING: "SETTINGS_ID",
  TYPE_LEFT_BLOCK_FOOTER: "FOOTER_ID",
  TYPE_LEFT_BLOCK_NAV: "NAV_ID",
  TYPE_LEFT_BLOCK_CONTENT: "CONTENT_ID",
  TYPE_LEFT_BLOCK_CAT: "CAT_ID",
  TYPE_LEFT_BLOCK_TESTIMONAIL: "Testimonials_ID",
  TYPE_LEFT_BLOCK_HTML: "HTML_ID",
  TYPE_LEFT_BLOCK_LOGO: "LOGO_ID",
  TYPE_LEFT_BLOCK_TEAM: "TEAM_ID",
  TYPE_LEFT_BLOCK_FORM: "FOMR_ID",
  TYPE_LEFT_BLOCK_CARDS: "CARDS_ID",
  TYPE_LEFT_BLOCK_TABLE: "TABLE_ID",
  TYPE_LEFT_BLOCK_NAVBAR: "NAVBAR_ID",
};

const PANEL_BLOCKS_LABELS = {
  /*
  HEADER_WITH_SB_BTN: "Header with sublinks and button",
  HEADER_WITH_LN_BTN: "Header with links and buttons",
  HEADER_WITH_HB_MN: "Header with hamburger menu",
  HEADER_WITH_IC_DC: "Header with sublinks, icons and description",
  */
  HEADER_BLOCK_1: "Header Block 1",
  HEADER_BLOCK_2: "Header Block 2",
  HEADER_BLOCK_3: "Header Block 3",
  HEADER_BLOCK_4: "Header Block 4",
  HEADER_BLOCK_5: "Header Block 5",
  HEADER_BLOCK_6: "Header Block 6",
  HEADER_BLOCK_7: "Header Block 7",
  HEADER_BLOCK_8: "Header Block 8",
  HEADER_BLOCK_9: "Header Block 9",
  HEADER_BLOCK_10: "Header Block 10",

  HEADER_BLOCK_11: "Header Block 11",
  HEADER_BLOCK_12: "Header Block 12",
  HEADER_BLOCK_13: "Header Block 13",
  HEADER_BLOCK_14: "Header Block 14",
  HEADER_BLOCK_15: "Header Block 15",
  HEADER_BLOCK_16: "Header Block 16",
  HEADER_BLOCK_17: "Header Block 17",
  HEADER_BLOCK_18: "Header Block 18",
  HEADER_BLOCK_19: "Header Block 19",
  HEADER_BLOCK_20: "Header Block 20",
};

export const LEFT_PANEL_METADATA_BLOCKS = [
  {
    title: LEFT_PANEL_BLOCKS_NAV,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_NAVBAR,
    iconImg:'pointer-01.svg',
    description:
      "This is where you can select Navigation Bar for you application. Note that the selected Navbar can be further configured to different colors and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "NavBar Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a01.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s1,        
      },
      {
        label: "NavBar Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a02.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s2,        
      },
      {
        label: "NavBar Block 3",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a03.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s3,        
      },
      {
        label: "NavBar Block 4",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a04.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s4,        
      },
      {
        label: "NavBar Block 5",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a05.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s5,        
      },
      {
        label: "NavBar Block 6",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a06.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s6,        
      },
      {
        label: "NavBar Block 7",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a07.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s7,        
      },
      {
        label: "NavBar Block 8",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a08.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s8,        
      },
      {
        label: "NavBar Block 9",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a09.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s9,        
      },
      {
        label: "NavBar Block 10",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a10.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s10,        
      },
      {
        label: "NavBar Block 11",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a11.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s11,        
      },
      {
        label: "NavBar Block 12",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a12.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s12,        
      },
      {
        label: "NavBar Block 13",
        image: "https://freshflowxyz.b-cdn.net/assets/section/navbar_a13.jpg",
        metadata: JSONS_RESTYLE.NAVBAR_BLOCK_s13,        
      },

      {
        label: "NavBar Block 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Navigation_01.jpg",
        metadata: JSONS.NAVBAR_BLOCK_1,        
      },
    ],
  },
  {
    title: LEFT_PANEL_BLOCKS_HEADER,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_HEADER,
    iconImg:'layout-top.svg',
    description:
      "This is where you can select Header for you application. Note that the selected Header can be further configured to different colors, combinations and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_1,
        image: "https://freshflowxyz.b-cdn.net/assets/section/Header_01.jpg",
        metadata: JSONS.HEADER_BLOCK_01, 
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_2,
        image: "https://freshflowxyz.b-cdn.net/assets/section/Header_02.jpg",
        metadata: JSONS.HEADER_BLOCK_02,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_3,
        image: "https://freshflowxyz.b-cdn.net/assets/section/Header_03.jpg",
        metadata: JSONS.HEADER_BLOCK_04,
      },

      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_1,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a01.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S01,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_2,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a02.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S02,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_3,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a03.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S03,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_4,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a04.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S04,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_5,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a05.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S05,      },
      
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_6,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a06.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S06,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_7,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a07.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S07,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_8,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a08.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S08,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_9,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a09.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S09,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_10,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a10.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S10,
      },
      
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_11,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a11.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S11,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_12,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a12.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S12,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_13,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a13.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S13,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_14,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a14.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S14,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_15,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a15.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S15,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_16,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a16.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S16,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_17,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a17.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S17,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_18,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a18.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S18,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_19,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a19.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S19,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_20,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a20.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S20,
      },
      
      
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_21,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a21.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S21,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_22,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a22.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S22,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_23,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a23.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S23,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_24,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a24.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S24,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_25,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a25.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S25,
      },
      
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_26,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a26.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S26,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_27,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a27.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S27,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_28,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a28.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S28,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_29,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a29.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S29,
      },
      {
        label: PANEL_BLOCKS_LABELS.HEADER_BLOCK_30,       
        image: "https://freshflowxyz.b-cdn.net/assets/section/header_a30.jpg",   
        metadata: JSONS_RESTYLE.HEADER_BLOCK_S30,
      },

      
      /* {
        label: "HERO Panel 1",
        image:
          "https://via.placeholder.com/500",
        metadata: JSONS.HERO_BLOCK_1,
      },
      {
        label: "HERO Panel 1",
        image:
          "https://via.placeholder.com/500",
        metadata: JSONS.HERO_BLOCK_3,
      }, */
    ],
  },
  {
    title: LEFT_PANEL_BLOCK_CARDS,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_CARDS,
    iconImg:'perspective.svg',
    description:
      "This is where you can 'Design Your Own Card' to display data. You can add elements like Text, Images, Video, Buttons, Links to cards as needed in any combination. You can also add Filter functionalty to cards.",
    showItemsRow: 2,
    subMenu: [
      /* {
        label: "Cards Section 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Cards_01.jpg",
        metadata: JSONS.GenericCardMetadata,
      }, */
      {
        label: 'Design Your Own Card 1',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a01.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_01,
      },
      {
        label: 'Design Your Own Card 2',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a02.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_02,
      },
      {
        label: 'Design Your Own Card 3',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a03.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_03,
      },
      {
        label: 'Design Your Own Card 4',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a04.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_04,
      },
      {
        label: 'Design Your Own Card 5',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a05.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_05,
      },
      {
        label: 'Design Your Own Card 6',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a06.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_06,
      },
      {
        label: 'Design Your Own Card 7',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a07.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_07,
      },
      {
        label: 'Design Your Own Card 8',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a08.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_08,
      },
      {
        label: 'Design Your Own Card 9',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a09.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_09,
      },
      {
        label: 'Design Your Own Card 10',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a10.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_10,
      },
      {
        label: 'Design Your Own Card 11',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a11.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_11,
      },
      {
        label: 'Design Your Own Card 12',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a12.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_12,
      },
      {
        label: 'Design Your Own Card 13',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a13.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_13,
      },
      {
        label: 'Design Your Own Card 14',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a14.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_14,
      },
      {
        label: 'Design Your Own Card 15',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_a15.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_15,
      },


      {
        label: 'Design Your Own Card b1',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b01.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b01,
      },
      {
        label: 'Design Your Own Card b2',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b02.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b02,
      },
      {
        label: 'Design Your Own Card b3',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b03.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b03,
      },
      {
        label: 'Design Your Own Card b4',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b04.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b04,
      },
      {
        label: 'Design Your Own Card b5',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b05.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b05,
      },
      {
        label: 'Design Your Own Card b6',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b06.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b06,
      },
      {
        label: 'Design Your Own Card b7',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b07.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b07,
      },
      {
        label: 'Design Your Own Card b8',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b08.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b08,
      },
      {
        label: 'Design Your Own Card b9',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b09.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b09,
      },
      {
        label: 'Design Your Own Card b10',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b10.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b10,
      },
      {
        label: 'Design Your Own Card b11',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b11.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b11,
      },
      {
        label: 'Design Your Own Card b12',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b12.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b12,
      },
      {
        label: 'Design Your Own Card b13',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b13.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b13,
      },
      {
        label: 'Design Your Own Card b14',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b14.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b14,
      },
      {
        label: 'Design Your Own Card b15',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_b15.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_b15,
      },

      {
        label: 'Design Your Own Card c1',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c01.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c01,
      },
      {
        label: 'Design Your Own Card c2',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c02.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c02,
      },
      {
        label: 'Design Your Own Card c3',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c03.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c03,
      },
      {
        label: 'Design Your Own Card c4',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c04.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c04,
      },
      {
        label: 'Design Your Own Card c5',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c05.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c05,
      },
      {
        label: 'Design Your Own Card c6',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c06.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c06,
      },
      {
        label: 'Design Your Own Card c7',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c07.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c07,
      },
      {
        label: 'Design Your Own Card c8',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c08.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c08,
      },
      {
        label: 'Design Your Own Card c9',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c09.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c09,
      },
      {
        label: 'Design Your Own Card c10',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c10.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c10,
      },
      {
        label: 'Design Your Own Card c11',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c11.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c11,
      },
      {
        label: 'Design Your Own Card c12',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c12.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c12,
      },
      {
        label: 'Design Your Own Card c13',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c13.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c13,
      },
      {
        label: 'Design Your Own Card c14',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c14.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c14,
      },
      {
        label: 'Design Your Own Card c15',       
        image: "https://freshflowxyz.b-cdn.net/assets/section/cards_c15.jpg",   
        metadata: JSONS_RESTYLE.CARDS_BLOCK_c15,
      },

      {
        label: "Design Your Own Card",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Cards_01.jpg",
        metadata: JSONS.DesignCardsMetadata,
      },
    ],
  },
  {
    title: LEFT_PANEL_BLOCKS_TABLE,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_TABLE,
    iconImg:'pointer-01.svg',
    description:
      "This is where you can select Table for you application. Note that the selected Table can be further configured to different colors and available controls.",
    showItemsRow: 2,
    subMenu: [   
      {
        label: "Dynamic Table Block 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/table_c01.jpg",
        metadata: JSONS_RESTYLE.TABLE_BLOCK_01,    
      },
      {
        label: "Dynamic Table Block 2",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/table_c02.jpg",
        metadata: JSONS_RESTYLE.TABLE_BLOCK_02,    
      },
      {
        label: "Dynamic Table Block 3",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/table_c03.jpg",
        metadata: JSONS_RESTYLE.TABLE_BLOCK_03,    
      },
      {
        label: "Dynamic Table Block 4",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/table_c04.jpg",
        metadata: JSONS_RESTYLE.TABLE_BLOCK_04,    
      },
    ],
  },
  {
    title: LEFT_PANEL_BLOCKS_HTML,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_HTML,
    iconImg:'embed.svg',
    description:
      "This is where you can select HTML section when you want to add adhoc html/javascript to your application. You can further configure it with various backgrounds and alignments as well.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "HTML Section 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/HTML_01.jpg",
        metadata: JSONS.HTML_BLOCK,
      },
    ],
  },
  {
    title: LEFT_PANEL_BLOCKS_LOGO,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_LOGO,
    iconImg:'color-swatch-01.svg',
    description:
      "This is where you can add Logo section to your application and showcase your customers. You can further configure this sections with various options.",
    showItemsRow: 1,
    subMenu: [
      {
        label: "Logos Section 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Logos_01.jpg",
        metadata: JSONS.LOGOS_BLOCK_1,
      },
    ],
  },
  {
    title: LEFT_PANEL_BLOCKS_FAQ,
    blockId: PANEL_BLOCKS_TYPES.LEFT_PANEL_BLOCKS_FAQ,
    iconImg:'message-typing.svg',
    description:
      "This is where you can select Features section for you application. Note that the selected Features Block can be further configured to different colors, combinations and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "FAQ Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a01.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s1,        
      },
      {
        label: "FAQ Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a02.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s2,        
      },
      {
        label: "FAQ Block 3",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a03.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s3,        
      },
      {
        label: "FAQ Block 4",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a04.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s4,        
      },
      {
        label: "FAQ Block 5",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a05.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s5,        
      },
      {
        label: "FAQ Block 6",
        image: "https://freshflowxyz.b-cdn.net/assets/section/faq_a06.jpg",
        metadata: JSONS_RESTYLE.FAQ_BLOCK_s6,        
      },

      {
        label: "FAQ Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/FAQ_01.jpg",
        metadata: JSONS.FAQ_BLOCK_1,
      },
    ],
  },
  /* {
    title: LEFT_PANEL_BLOCKS_CONTENT,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_CONTENT,
    description:
      "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away",
    showItemsRow: 2,
    subMenu: [
      {
        label: "Content Panel",
        image:
          "https://via.placeholder.com/500",
        metadata: JSONS.CONTENT_BLOCK,
      },
    ],
  }, */
  /* DEVELOP new feature section */
  /*{
    title: LEFT_PANEL_BLOCKS_FEATURE,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_FEATURE,
    iconImg:'check-square-broken.svg',
    description:
      "This is where you can select Features section for you application. Note that the selected Features Block can be further configured to different colors, combinations and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "Feature Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Features_01.jpg",
        metadata: JSONS.FEATURE_BLOCK_2,
      },
    ],
  },*/
  /* {
    title: LEFT_PANEL_BLOCKS_TEAM,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_TEAM,
    description:
      "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away",
    showItemsRow: 2,
    subMenu: [],
  },
  {
    title: LEFT_PANEL_BLOCKS_FORM,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_FORM,
    description:
      "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away",
    showItemsRow: 2,
    subMenu: [],
  }, */
  {
    title: LEFT_PANEL_BLOCKS_CTA,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_CAT,
    iconImg:'cursor-pointer.svg',
    description:
      "This is where you can select CTA (Call-To-Action) section for you application. Note that the selected CTA Block can be further configured to different colors, combinations and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "CTA Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/cta_a01.jpg",
        metadata: JSONS_RESTYLE.CTA_BLOCK_s1,        
      },
      {
        label: "CTA Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/cta_a02.jpg",
        metadata: JSONS_RESTYLE.CTA_BLOCK_s2,        
      },
      {
        label: "CTA Block 3",
        image: "https://freshflowxyz.b-cdn.net/assets/section/cta_a03.jpg",
        metadata: JSONS_RESTYLE.CTA_BLOCK_s3,        
      },
      {
        label: "CTA Block 4",
        image: "https://freshflowxyz.b-cdn.net/assets/section/cta_a04.jpg",
        metadata: JSONS_RESTYLE.CTA_BLOCK_s4,        
      },
      {
        label: "CTA Block 5",
        image: "https://freshflowxyz.b-cdn.net/assets/section/cta_a05.jpg",
        metadata: JSONS_RESTYLE.CTA_BLOCK_s5,        
      },
      {
        label: "CTA Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/CTA_01.jpg",
        metadata: JSONS.CTA_01_BLOCK,
      },
      {
        label: "CTA Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/CTA_02.jpg",
        metadata: JSONS.CTA_02_BLOCK,
      },
    ],
  },
  /* {
    title: LEFT_PANEL_BLOCKS_TESTIMONIAL,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_TESTIMONAIL,
    description:
      "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away",
    showItemsRow: 2,
    subMenu: [],
  }, */
  /* {
    title: LEFT_PANEL_BLOCKS_PRICING,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_PRICING,
    description:
      "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away",
    showItemsRow: 2,
    subMenu: [
      {
        label: "Pricing Panel",
        image:
          "https://via.placeholder.com/500",
        metadata: JSONS.PRICING_BLOCK_1,
      },
      {
        label: "Pricing New",
        image:
          "https://via.placeholder.com/500",
        metadata: JSONS.PRICING_01,
      },
    ],
  }, */
  {
    title: LEFT_PANEL_BLOCKS_FOOTER,
    blockId: PANEL_BLOCKS_TYPES.TYPE_LEFT_BLOCK_FOOTER,
    iconImg:'layout-bottom.svg',
    description:
      "This is where you can select Footer for you application. Note that the selected Footer can be further configured to different colors, combinations and available controls.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "Footer Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Footer_01.jpg",
        metadata: JSONS.FOOTER_BLOCK_1,
      },
      {
        label: "Footer Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/Footer_02.jpg",
        metadata: JSONS.FOOTER_BLOCK_2,
      },
      
      {
        label: "Footer Block 1",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a01.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s1,        
      },
      {
        label: "Footer Block 2",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a02.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s2,        
      },
      {
        label: "Footer Block 3",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a03.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s3,        
      },
      {
        label: "Footer Block 4",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a04.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s4,        
      },
      {
        label: "Footer Block 5",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a05.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s5,        
      },
      {
        label: "Footer Block 6",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a06.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s6,        
      },
      {
        label: "Footer Block 7",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a07.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s7,        
      },
      {
        label: "Footer Block 8",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a08.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s8,        
      },
      {
        label: "Footer Block 9",
        image: "https://freshflowxyz.b-cdn.net/assets/section/footer_a09.jpg",
        metadata: JSONS_RESTYLE.FOOTER_BLOCK_s9,        
      },

      
    ],
  },
  {
    title: "Elements",
    blockId: "Element_1",
    iconImg:'layers-02.svg',
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    showItemsRow: 2,
    subMenu: [
      {
        label: "Video Element 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Elements_Video_01.jpg",
        metadata: JSONS.VIDEO_ELEMENT_BLOCK,
      },
      {
        label: "Image Element 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Elements_Image_01.jpg",
        metadata: JSONS.IMAGE_ELEMENT_BLOCK,
      },
      {
        label: "Text Element 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Elements_Text_01.jpg",
        metadata: JSONS.TEXT_ELEMENT_BLOCK,
      },
      {
        label: "Buttons Element 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Elements_Button_01.jpg",
        metadata: JSONS.BUTTONS_ELEMENT_BLOCK,
      },
      {
        label: "Image Slider 1",
        image:
          "https://freshflowxyz.b-cdn.net/assets/section/Image_Slider_01.jpg",
        metadata: JSONS.CAROUSEL_ELEMENT_BLOCK,
      },
    ],
  },
];
